<template>
  <div class="body" @contextmenu.prevent>
    <transition name="el-zoom-in-bottom">
      <child-driveHeadThemec ref="childDriveHeadThemec" @child-event="showDriveHead"></child-driveHeadThemec>
    </transition>
  
      
    <transition name="el-zoom-in-bottom">
      <child-driveHomec ref="childDriveHomec"></child-driveHomec>
    </transition>


    <transition name="el-zoom-in-bottom">
      <child-driveFooterThemec ref="childDriveFooterThemec"></child-driveFooterThemec>
    </transition>

  </div>

</template>
<script>
import KeyboardMapConf from '../keyboard.map.json';
import cmd10 from '../cmd1.0.config.json';
//导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../asserts/js/hid_device.js';
import { ToolsHandle } from '../../utils/tools.js';

//获取主题配置文件
import ThemeConf from './theme.config.json';
//组件
import driveHeadThemeC from '../templates/t2/components/head.vue'
import driveFooterThemeC from '../templates/t2/components/footer.vue'
import driveHomeC from '../templates/t2/home.vue'

export default {
  name: 'app',
  components: 
  {
    'child-driveHeadThemec':driveHeadThemeC,
    'child-driveFooterThemec':driveFooterThemeC,
    'child-driveHomec':driveHomeC
  },
  data() {
    return {

      showIndex:true,
      show:false,
      showHF:false
    }
  },
  async mounted()
  {
    //主题颜色
    this.themeInit();
    //禁止拖拽网页图片
    document.addEventListener('dragstart', this.preventImageDrag);

    //映射HID事件到VUE
    this.navigator = window.navigator;
    navigator.hid.addEventListener('connect', this.connectRFIDs);
    navigator.hid.addEventListener('disconnect', this.disconnectRFIDs);

    //设置驱动页面调用对象
    HIDDeviceObj.curWebHandle = this;
    //获取HID设备连接历史列表
    this.getDeviceList();
    await ToolsHandle.delay(1000);

    this.init();

  },
  beforeDestroy() 
  {
    document.removeEventListener('dragstart', this.preventImageDrag);
  },
  methods: 
  {
    themeInit()
    {
      // console.log(ThemeConf);
      //主题切换 //"light-theme";//"dark-theme";
      document.body.className = localStorage.getItem('theme') || ThemeConf.theme;
    },
    //初始化设备
    async init()
    {
      //获取子组件对象
      const ChildDriveHeadThemeC = this.$refs.childDriveHeadThemec;
            ChildDriveHeadThemeC.ThemeConf = ThemeConf;
            
      const ChildDriveFooterThemeC = this.$refs.childDriveFooterThemec;
            ChildDriveFooterThemeC.ThemeConf = ThemeConf;

      const ChildDriveHomeC = this.$refs.childDriveHomec;
            ChildDriveHomeC.setDeviceObj(HIDDeviceObj,ThemeConf);

      if(HIDDeviceObj.curDeviceHandle !== null)
      {
          // ChildDriveHomeC.load();
          //发送读取键盘矩阵信息
          HIDDeviceObj.redMatrix(cmd10);
          await ToolsHandle.delay(2000);

          //格式结构化键盘矩阵对象
          HIDDeviceObj.formatKeyMapMatrix(KeyboardMapConf);
          ChildDriveHeadThemeC.curHIDDeviceObj = HIDDeviceObj;
          ChildDriveHeadThemeC.updateList();

          ChildDriveHomeC.setDeviceObj(HIDDeviceObj,ThemeConf);

      }
    },
    // 断开重新连接上的时候会触发这个方法
    async connectRFIDs(event) 
    {
      console.log("onconnect: ", event.device);
      // 之所以判断，是因为有可能，有可能设备之前关闭了，你需要连接上重新打开，但是界面上面没有任何变动
      // if (!event.device.opened) 
      // {
      //   this.device = event.device
      //   // await this.device.open()
      // }

      //更新设备列表
      // const ChildDriveHeadThemeC = this.$refs.childDriveHeadThemec;
      // ChildDriveHeadThemeC.curHIDDeviceObj = null;
      // this.getDeviceList();
      // setTimeout(()=>{this.init();},500);

      setTimeout(()=>{window.location.reload();},1000);
    },
    async disconnectRFIDs(event) 
    {
      console.log("ondisconnect: ", event.device);
      // 这是断开链接时，将没有关闭的设备关闭
      if (event.device.opened) //(HIDDeviceObj.curDeviceHandle != null && HIDDeviceObj.curDeviceHandle.opened) 
      {
          await event.device.close();
          
          //更新设备列表
          const ChildDriveHeadThemeC = this.$refs.childDriveHeadThemec;
          ChildDriveHeadThemeC.curHIDDeviceObj = null;

          // const ChildDriveHomeC = this.$refs.childDriveHomec;
          // ChildDriveHomeC.warn();
          // this.getDeviceList();
          // setTimeout(()=>{this.init();},500);

          setTimeout(()=>{window.location.reload();},1000);
          
      }

    },
    //获取HID连接设备历史
    async getDeviceList()
    {
        const devices = await navigator.hid.getDevices();
        for (const device of devices) 
        {
            if(device.collections[0].usagePage != ThemeConf.FWUsagePage)
                continue;

            //打开设备
            await device.open();
            // 监听来自HID设备的数据
            device.oninputreport = (e) => 
            {
                const reData = new Uint8Array(e.data.buffer);
                const cmdCode = reData[2];
                const typeCode = reData[5];

                //获取设备信息，需要对回报数据做判断处理
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.DEVICE_CODE))
                {
                    const DeviceInfo = HIDDeviceObj.getDeviceInfoXS(reData);
                    console.log(DeviceInfo);

                    //对比连接设备ID映射,并打开第一个驱动列表
                    for(let [index, confDeviceItem] of ThemeConf.DeviceList.entries())
                    {
                      if(confDeviceItem.BoardID == DeviceInfo.BoardID)
                      {
                          HIDDeviceObj.curDeviceHandle = device;
                          HIDDeviceObj.FirmwareVer = confDeviceItem.FirmwareVer;
                          HIDDeviceObj.FirmwareFull = confDeviceItem.FirmwareVer + '.' + DeviceInfo.Version;
                          HIDDeviceObj.RunMode = DeviceInfo.RunMode;
                          HIDDeviceObj.curDeviceMode = confDeviceItem.model;
                      }
                    }
                }
                
                //读取键盘矩阵布局
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.RM6X21_CODE))
                {
                    HIDDeviceObj.setMatrixKey(reData);
                }

                //实时ADC采样数据处理
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.RM6X21_JOURNEY_CODE))
                {
                  HIDDeviceObj.setMatrixJourneyHeadData(reData,cmd10);
                }
                else
                {//其他没有头文件的包数据
                  HIDDeviceObj.setMatrixJourneyNOHeadData(reData,cmd10);
                }


                //LAYOUT读取数据处理
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.RM6X21_LAYOUT0_CODE))
                {
                  HIDDeviceObj.setMatrixLayoutData(reData,cmd10,HIDDeviceObj);
                }

                //读取全局RT响应全行程状态数据
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.RT_ALL_JOURNEY_CODE))
                {
                  HIDDeviceObj.setRTJourneyAllData(reData,HIDDeviceObj);
                }
                
                //读取全局行程数据
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.GLOBAL_JOURNEY_CODE))
                {
                  HIDDeviceObj.setGlobalJourneyData(reData,HIDDeviceObj);
                }

                //读取全局灯光数据
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.GLOBAL_LIGTH_CODE))
                {
                  HIDDeviceObj.setGlobalLigthData(reData,HIDDeviceObj);
                }

                //读取全局功能数据
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.GLOBAL_FUNC_CODE))
                {
                  HIDDeviceObj.setGlobalFuncData(reData,cmd10,HIDDeviceObj);
                }

                //升级签名
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.UPGRADE.SIGN))
                {
                  HIDDeviceObj.setUpgradeSignFuncData(reData,cmd10,HIDDeviceObj);
                }

                //升级CRC
                if(parseInt(cmdCode) == parseInt(cmd10.RESPONSE_CODE.UPGRADE.RCRC))
                {
                  HIDDeviceObj.setUpgradeCRCData(reData,cmd10,HIDDeviceObj);
                }
                
            };

            //发送读取设备信息命令
            setTimeout(function()
            {
                const outputReportData = new Uint8Array(cmd10.READ_DEVICE_INFO_CMD.map(hex => parseInt(hex, 16)));
                device.sendReport(0, outputReportData);

                ToolsHandle.delay(100);
                //读取当前配置
                const profileReportData = new Uint8Array(cmd10.READ_DEVICE_PROFILE_CMD.map(hex => parseInt(hex, 16)));
                device.sendReport(0, profileReportData);

            },300);
        }

    },

    refreshHIDeviceData()
    {
      const ChildDriveHomeC = this.$refs.childDriveHomec;
            ChildDriveHomeC.refreshData(HIDDeviceObj);
    },
    //点击显示设备驱动
    showDriveHead(FirmwareVer) 
    {
        console.log(FirmwareVer);
    },
    preventImageDrag(event) 
    {
      // 检查是否是图片
      if (event.target.tagName.toUpperCase() === 'IMG') 
      {
        event.preventDefault();
      }
    }
  },
  computed: {

  }
}

</script>